interface RevampTeaserProps {
    text: string;
}

/** Teaser paragraph with a serif drop cap, per the Figma teaser module. */
export const RevampTeaser = ({ text }: RevampTeaserProps) => {
    return (
        <p className="m-0 mx-auto w-full px-4.5 font-serif text-[1.125rem] leading-[1.8] text-black first-letter:float-left first-letter:mt-2 first-letter:mr-6 first-letter:font-gestura first-letter:text-[4.5rem] first-letter:leading-[0.75] md:w-[56.125rem] md:px-0 md:text-[1.25rem] md:leading-[2rem] md:first-letter:mr-[0.7rem] md:first-letter:text-[7rem]">
            {text}
        </p>
    );
};
